import { render, staticRenderFns } from "./companiesList.vue?vue&type=template&id=98aedacc&scoped=true&"
import script from "./companiesList.vue?vue&type=script&lang=js&"
export * from "./companiesList.vue?vue&type=script&lang=js&"
import style0 from "./companiesList.vue?vue&type=style&index=0&id=98aedacc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aedacc",
  null
  
)

export default component.exports